import { Component, input } from '@angular/core';
import { RateTheme } from '@shared/components/rate/enum/rate-theme';
import { MeanArrayPipe } from '@shared/components/rate/pipe';
import { IconsDirective } from '@shared/directives';

@Component({
  selector: 'app-rate',
  styleUrl: './rate.component.scss',
  templateUrl: './rate.component.html',
  imports: [IconsDirective, MeanArrayPipe],
})
export class RateComponent {
  readonly mean = input.required<number>();
  readonly advice = input<number>();
  readonly size = input('2.4rem');
  readonly url = input<string>();
  readonly theme = input<keyof typeof RateTheme>('BROWN');
}
